import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

const ITEMS = [
  { type: "section", label: "Movimiento" },
  { label: "Solicitud de Traspaso", icon: "fas fa-file-export", color: "#10b981", bg: "#f0fdf4", href: "/ListadoTraspasosSolicitud", desc: "Solicitudes de traspaso", perm: "menu_traspasos_salida" },
  { label: "Traspasos Salida", icon: "fas fa-sign-out-alt", color: "#3b82f6", bg: "#eff6ff", href: "/ListadoTraspasosSalida", desc: "Salidas entre áreas", perm: "menu_traspasos_salida" },
  { label: "Traspasos Entrada", icon: "fas fa-sign-in-alt", color: "#f59e0b", bg: "#fffbeb", href: "/ListadoTraspasosEntrada", desc: "Entradas entre áreas", perm: "menu_traspasos_entrada" },
  { type: "section", label: "Cuenta" },
  { label: "Abonos", icon: "fas fa-dollar-sign", color: "#8b5cf6", bg: "#f5f3ff", href: "/ListadoAbonosTraspasos", desc: "Abonos de traspasos", perm: "abonos" },
  { label: "Estado Cuenta", icon: "fas fa-file-invoice-dollar", color: "#0ea5e9", bg: "#f0f9ff", href: "/EstadoCuentaTraspasos", desc: "Estado de cuenta por área", perm: "edoCtaClientes" },
  { type: "section", label: "Reportes" },
  { label: "Reporte Traspasos", icon: "fas fa-clipboard-list", color: "#f43f5e", bg: "#fff1f2", href: "/ReporteTraspasos", desc: "Reporte de traspasos", perm: "menu_traspasos_salida" },
];

function BotonesTraspasos() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-exchange-alt" color="#14b8a6" bg="#f0fdfa" title="Traspasos" subtitle="Movimiento de mercancía entre áreas" />
        {user.menu_inventarios ? (
          <div className="row">
            {ITEMS.map((r, i) =>
              r.type === "section"
                ? <MenuSection key={i} title={r.label} />
                : <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
            )}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesTraspasos;
